import React from 'react';
import classNames from 'classnames';

import {ChecklistItem} from 'src/types/store';

import TextButton from 'src/components/TextButton';
import Button from 'src/components/button';
import Icon from 'shared/components/icon';

interface Props {
  onPreviousItem: () => void;
  onNextItem: () => void;
  onSkipChecklistItem: () => void;
  onCourseAdd: () => void;
  activeItemIndex: number;
  itemComplete: boolean;
  checklistComplete: boolean;
  itemsTotal: number;
  item: ChecklistItem | undefined;
  tipContent: string;
}

const ChecklistFooter = ({
  onPreviousItem,
  onNextItem,
  onSkipChecklistItem,
  onCourseAdd,
  activeItemIndex,
  itemsTotal,
  itemComplete,
  checklistComplete,
  item,
  tipContent,
}: Props) => {
  const finishedChecklistCopy = (
    <p className="portfolio-checklist-completed-copy">
      <strong>Pro Tip:</strong> {tipContent}
    </p>
  );

  const ctaContent = item && (
    <div>
      {item.allowSkip && (
        <TextButton disabled={!item.allowSkip} onClick={onSkipChecklistItem}>
          Does not apply to me
        </TextButton>
      )}
      <Button
        horizontalMargin
        buttonName={`checklist item ${item.ctaLabel}`}
        onClick={item.cta}
        className="checklist-item-cta-button"
      >
        {item.ctaLabel}
      </Button>
    </div>
  );

  const disabled = activeItemIndex === 0;
  const previousNextButtons = (
    <div className="portfolio-checklist-buttons-container">
      <Button
        color="gray-link"
        onClick={onPreviousItem}
        disabled={disabled}
        className={classNames('portfolio-checklist-previous-next-button', {disabled})}
      >
        <Icon iconType="chevron-left" className="previous-button-icon" />
        Previous
      </Button>
      <Button
        color="gray-link"
        disabled={activeItemIndex === itemsTotal - 1}
        onClick={onNextItem}
        className="portfolio-checklist-previous-next-button next-button"
      >
        Next
        <Icon iconType="chevron-right" className="next-button-icon" />
      </Button>
    </div>
  );

  return (
    <div className="portfolio-checklist-footer">
      {checklistComplete ? finishedChecklistCopy : previousNextButtons}
      {!itemComplete && ctaContent}
      {checklistComplete && (
        <Button horizontalMargin className="checklist-item-cta-button" onClick={onCourseAdd}>
          Add Course
        </Button>
      )}
    </div>
  );
};

export default ChecklistFooter;
